import { Button, type ButtonProps } from '@progress/kendo-react-buttons'
import { Tooltip } from '@progress/kendo-react-tooltip'
import React from 'react'

export type TooltipButtonProps = Omit<
  ButtonProps,
  'onMouseEnter' | 'onMouseLeave'
> &
  Required<Pick<ButtonProps, 'title'>> & {
    'data-testid'?: string
  }

export const TooltipButton = ({
  'data-testid': dataTestId = 'components-elements-tooltip-button',
  ...props
}: TooltipButtonProps) => {
  const tooltip = React.createRef<Tooltip>()

  return (
    <>
      <Button
        data-testid={dataTestId}
        onMouseEnter={tooltip.current?.handleMouseOver}
        onMouseLeave={tooltip.current?.handleMouseOut}
        {...props}
      />

      <Tooltip
        ref={tooltip}
        anchorElement="target"
        openDelay={100}
        position="top"
      />
    </>
  )
}
